'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _option = require('../option');

var _option2 = _interopRequireDefault(_option);

var _OtherOptionInput = require('./OtherOptionInput');

var _OtherOptionInput2 = _interopRequireDefault(_OtherOptionInput);

var _OtherOptionControl = require('./OtherOptionControl');

var _OtherOptionControl2 = _interopRequireDefault(_OtherOptionControl);

var _LoadMore = require('./LoadMore');

var _LoadMore2 = _interopRequireDefault(_LoadMore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Options = function (_React$Component) {
  _inherits(Options, _React$Component);

  _createClass(Options, null, [{
    key: 'getOtherInputValueAlreadySet',

    // returns undefined if all the values are known options.
    // otherwise returns the first unknown value, assume that was entered in the "other" field.
    value: function getOtherInputValueAlreadySet(props) {
      var value = props.value,
          options = props.options,
          otherEnabled = props.otherEnabled;


      if (otherEnabled) {
        var valuesToCheck = typeof value === 'string' ? [value] : value;
        return valuesToCheck.find(function (v) {
          return options.every(function (o) {
            return o !== v;
          });
        });
      }
      return undefined;
    }
  }, {
    key: '_syncValuesAndOptions',
    value: function _syncValuesAndOptions(value, options) {
      var copy = options.slice(0);
      if (value && options) {
        value.forEach(function (v) {
          var index = copy.indexOf(v);

          if (index !== -1) {
            copy.splice(index, 1);
          }

          copy.unshift(v);
        });
      }
      return copy;
    }
  }, {
    key: '_getValue',
    value: function _getValue(value) {
      return typeof value === 'string' ? [value] : value;
    }
  }]);

  function Options(props) {
    _classCallCheck(this, Options);

    var _this = _possibleConstructorReturn(this, (Options.__proto__ || Object.getPrototypeOf(Options)).call(this, props));

    _this.options = [];

    _this._isExclusive = _this._isExclusive.bind(_this);
    _this._handleOnClick = _this._handleOnClick.bind(_this);
    _this._handleLoadMore = _this._handleLoadMore.bind(_this);
    _this._getOptionComponents = _this._getOptionComponents.bind(_this);
    _this._handleOnClickOther = _this._handleOnClickOther.bind(_this);
    _this._handleOnChangeOtherInput = _this._handleOnChangeOtherInput.bind(_this);
    _this.focus = _this.focus.bind(_this);

    var otherInputValueAlreadySet = Options.getOtherInputValueAlreadySet(props);

    _this.state = {
      loadMax: false,
      otherChecked: otherInputValueAlreadySet ? true : false,
      otherInputValue: otherInputValueAlreadySet ? otherInputValueAlreadySet : ''
    };
    return _this;
  }

  _createClass(Options, [{
    key: 'focus',
    value: function focus() {
      if (this.options && this.options.length > 0) {
        this.options[0].focus();
      }
    }
  }, {
    key: '_getOptionComponents',
    value: function _getOptionComponents(options) {
      var _this2 = this;

      var loadMax = this.state.loadMax;
      var _props = this.props,
          type = _props.type,
          maxShown = _props.maxShown,
          initShown = _props.initShown,
          loadMore = _props.loadMore,
          optionProps = _props.optionProps;

      var value = Options._getValue(this.props.value);

      var optionsLength = options ? options.length : 0;
      var max = maxShown !== -1 && optionsLength > maxShown ? maxShown : optionsLength;
      var min = value && value.length > initShown ? value.length : initShown;
      var displayCount = !loadMax && loadMore ? min : max;

      if (options && options.length > 0) {
        var optionsShown = options.slice(0, displayCount);
        var components = optionsShown.map(function (option) {
          return _react2.default.createElement(_option2.default, _extends({
            key: option,
            id: option,
            text: option,
            checked: value.indexOf(option) !== -1,
            value: option,
            type: type,
            onChange: _this2._handleOnClick.bind(null, option)
          }, optionProps, {
            ref: function ref(option) {
              _this2.options.push(option);
            }
          }));
        });

        return components;
      }
      return null;
    }

    // An exclusive option is one that is in a multi-value options list
    //   but isn't allowed to be selected along with other options.

  }, {
    key: '_isExclusive',
    value: function _isExclusive(option) {
      var exclusiveOptions = this.props.exclusiveOptions;

      return exclusiveOptions && exclusiveOptions.indexOf(option) > -1;
    }
  }, {
    key: '_handleOnClick',
    value: function _handleOnClick(option) {
      var _props2 = this.props,
          multiValue = _props2.multiValue,
          id = _props2.id,
          onChange = _props2.onChange;

      var value = Options._getValue(this.props.value);

      if (multiValue) {
        var newValue = value.slice(0, value.length);
        var index = newValue.indexOf(option);

        if (index !== -1) {
          // user is de-selecting the option.
          newValue.splice(index, 1);
        } else {
          // user is selecting the option.
          var oldValueIsExclusive = value.length === 1 && this._isExclusive(value[0]);
          var newValueIsExclusive = this._isExclusive(option);

          if (newValueIsExclusive || oldValueIsExclusive) {
            newValue = [option];
          } else {
            newValue.push(option);
          }

          if (newValueIsExclusive && this.state.otherChecked) {
            this.setState({ otherChecked: false, otherInputValue: '' });
          }
        }

        onChange(id, newValue);
      } else {
        this.setState({ otherChecked: false, otherInputValue: '' });
        onChange(id, option);
      }
    }
  }, {
    key: '_handleLoadMore',
    value: function _handleLoadMore() {
      this.setState({ loadMax: true });
    }
  }, {
    key: '_handleOnClickOther',
    value: function _handleOnClickOther() {
      var _props3 = this.props,
          id = _props3.id,
          multiValue = _props3.multiValue,
          onChange = _props3.onChange;
      var _state = this.state,
          otherChecked = _state.otherChecked,
          otherInputValue = _state.otherInputValue;

      var value = Options._getValue(this.props.value);

      if (multiValue && otherChecked) {
        var index = value.indexOf(otherInputValue);

        if (index !== -1) {
          var newValue = value.slice(0, value.length);
          newValue.splice(index, 1);
          onChange(id, newValue);
        }

        this.setState({ otherChecked: false, otherInputValue: '' });
      } else if (!otherChecked) {
        this.setState({ otherChecked: true });
        var oldValueIsExclusive = value.length === 1 && this._isExclusive(value[0]);

        if (!multiValue || oldValueIsExclusive) {
          onChange(id, '');
        }
      }
    }
  }, {
    key: '_handleOnChangeOtherInput',
    value: function _handleOnChangeOtherInput(inputId, inputValue) {
      var _props4 = this.props,
          id = _props4.id,
          multiValue = _props4.multiValue,
          onChange = _props4.onChange;
      var otherInputValue = this.state.otherInputValue;

      var value = Options._getValue(this.props.value);

      if (multiValue) {
        var newValue = value.slice(0, value.length);
        var index = value.indexOf(otherInputValue);

        if (index !== -1) {
          newValue.splice(index, 1, inputValue);
        } else {
          newValue.push(inputValue);
        }

        onChange(id, newValue);
      } else {
        onChange(id, inputValue);
      }

      this.setState({ otherInputValue: inputValue });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props5 = this.props,
          id = _props5.id,
          loadMore = _props5.loadMore,
          horizontal = _props5.horizontal,
          className = _props5.className,
          syncOptions = _props5.syncOptions,
          value = _props5.value,
          otherEnabled = _props5.otherEnabled,
          otherInputProps = _props5.otherInputProps,
          type = _props5.type,
          optionProps = _props5.optionProps;
      var _state2 = this.state,
          loadMax = _state2.loadMax,
          otherChecked = _state2.otherChecked,
          otherInputValue = _state2.otherInputValue;

      var options = syncOptions ? Options._syncValuesAndOptions(value, this.props.options) : this.props.options;
      var optionComponents = this._getOptionComponents(options);

      return _react2.default.createElement(
        'div',
        { id: id, className: 'pxl-options ' + className },
        _react2.default.createElement(
          'div',
          { className: '' + (horizontal ? 'pxl-options--horizontal' : '') },
          optionComponents,
          _react2.default.createElement(_OtherOptionControl2.default, {
            type: type,
            enabled: otherEnabled,
            checked: otherChecked,
            onChange: this._handleOnClickOther,
            optionProps: optionProps
          }),
          _react2.default.createElement(_OtherOptionInput2.default, {
            checked: otherChecked,
            onChange: this._handleOnChangeOtherInput,
            value: otherInputValue,
            inputProps: otherInputProps
          })
        ),
        _react2.default.createElement(_LoadMore2.default, {
          onClick: this._handleLoadMore,
          visible: !loadMax && loadMore && options && options.length > 0 && optionComponents && optionComponents.length < options.length
        })
      );
    }
  }]);

  return Options;
}(_react2.default.Component);

exports.default = Options;


Options.propTypes = {
  className: _propTypes2.default.string,
  exclusiveOptions: _propTypes2.default.array,
  horizontal: _propTypes2.default.bool,
  id: _propTypes2.default.string,
  initShown: _propTypes2.default.number,
  loadMore: _propTypes2.default.bool,
  maxShown: _propTypes2.default.number,
  multiValue: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  optionProps: _propTypes2.default.shape({
    className: _propTypes2.default.string
  }),
  options: _propTypes2.default.array,
  otherEnabled: _propTypes2.default.bool,
  otherInputProps: _propTypes2.default.object,
  syncOptions: _propTypes2.default.bool,
  type: _propTypes2.default.oneOf(['pills', 'checklist', 'radio']),
  value: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.string])
};

Options.defaultProps = {
  className: '',
  exclusiveOptions: [],
  horizontal: false,
  initShown: 5,
  loadMore: false,
  maxShown: -1,
  multiValue: true,
  optionProps: {
    className: ''
  },
  options: [],
  otherEnabled: false,
  otherInputProps: {},
  syncOptions: false,
  type: 'checklist',
  value: []
};